import React, { useEffect, useState } from "react";
import DashboardCard from "../components/Dashboard/Card";
import FilterDropdown from "../components/FilterDropdown/FilterDropdown";
import SortByDropdown from "../components/SortByDropdown/SortByDropdown";

import SkeletonCard from "../components/SkeletonCard";
import { useDispatch, useSelector } from "react-redux";
import { getFilteredCalls } from "../store/Slice/DashboardSlice";

const Dashboard = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.dashboard);

  const [filters, setFilters] = useState({
    status: [],
    segment: [],
  });
  const [sortBy, setSortBy] = useState("newest_first");
  const [isFiltered, setIsFiltered] = useState(false);

  useEffect(() => {
    if (!isFiltered) {
      dispatch(
        getFilteredCalls({
          filters: null,
          sortBy: "newest_first",
          endpoint: "calls/filter",
        })
      );

      const refreshInterval = setInterval(() => {
        console.log("Auto-refreshing dashboard data...");
        dispatch(
          getFilteredCalls({
            filters: null,
            sortBy: "newest_first",
            endpoint: "calls/filter",
          })
        );
      }, 300000);

      return () => clearInterval(refreshInterval);
    }
    return () => {};
  }, [dispatch, isFiltered]);

  const isLoading = loading;

  const handleChangeFilters = (newFilters) => {
    setFilters(newFilters);
  };

  const handleChangeSortBy = (newSortBy) => {
    setSortBy(newSortBy);
  };

  const handleApplyFilters = (appliedFilters = filters) => {
    console.log("Filters applied:", appliedFilters);
    const apiFilters = {};
    if (appliedFilters.status && appliedFilters.status.length > 0) {
      apiFilters.status = appliedFilters.status;
    }
    if (appliedFilters.segment && appliedFilters.segment.length > 0) {
      apiFilters.segment = appliedFilters.segment;
    }

    setIsFiltered(true);

    dispatch(
      getFilteredCalls({
        filters: Object.keys(apiFilters).length > 0 ? apiFilters : null,
        sortBy,
        endpoint: "calls/filter",
      })
    );
  };

  const handleApplySort = (appliedSortBy = sortBy) => {
    console.log("Sort applied:", appliedSortBy);

    const apiFilters = {};
    if (filters.status && filters.status.length > 0) {
      apiFilters.status = filters.status;
    }
    if (filters.segment && filters.segment.length > 0) {
      apiFilters.segment = filters.segment;
    }

    dispatch(
      getFilteredCalls({
        filters: Object.keys(apiFilters).length > 0 ? apiFilters : null,
        sortBy: appliedSortBy,
        endpoint: "calls/filter",
      })
    );

    setIsFiltered(true);
  };

  return (
    <div className="min-h-screen bg-[#f5f7fa]">
      <div className="max-w-[1440px] mx-auto p-4 lg:p-6">
        <div className="mb-6 bg-white shadow-sm  border-b border-t border-brand-border">
          <div className="flex items-center justify-start p-4 lg:p-6 flex-row gap-4">
            <h2 className="text-xl lg:text-[24px] xl:text-[24px] font-semibold text-[#454545]">
              Dashboard
            </h2>
            <div className="flex gap-3 w-auto justify-start flex-row items-center">
              <FilterDropdown
                filters={filters}
                onFiltersChange={handleChangeFilters}
                onApply={handleApplyFilters}
                sortBy={sortBy}
              />
              <SortByDropdown
                sortBy={sortBy}
                onSortChange={handleChangeSortBy}
                onApply={handleApplySort}
                filters={filters}
              />
            </div>
          </div>
        </div>

        <div className="w-full">
          {isLoading ? (
            <div className="flex flex-col gap-4 lg:gap-5 w-full">
              <SkeletonCard />
              <SkeletonCard />
              <SkeletonCard />
            </div>
          ) : (
            <DashboardCard />
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
